import React from 'react';
export const VoteArrowIcon = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { d: "M12 3.8l6.96 8.7H14.5v7h-5v-7H5.04L12 3.8z" })));
//# sourceMappingURL=vote-arrow-icon.js.map